module.exports = __webpack_public_path__ + "static/media/home2.fbdf4c4b.png";